(function () {
  const ROW = parseInt(getComputedStyle(document.documentElement)
               .getPropertyValue('--thumb-row-h')) || 80;

  function apply(root = document) {
    const lists = root.querySelectorAll(
      'ul[id^="Slider-Thumbnails-template"][class*="thumbnail-list"], .thumbnail-list.slider.slider--mobile'
    );
    lists.forEach(ul => {
      // タッチ方向の最適化（iOS対策）
      ul.style.touchAction = 'pan-x';
      ul.style.overscrollBehaviorY = 'contain';

      // 子LIの高さが外部JS/CSSで上書きされても戻す
      ul.querySelectorAll(':scope > li').forEach(li => {
        li.style.height = ROW + 'px';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => apply());
  // Shopifyセクションが差し替えられた時にも再適用
  document.addEventListener('shopify:section:load', e => apply(e.target));

  // 何かのJSがあとから高さを変える場合への保険
  const mo = new MutationObserver(() => apply());
  mo.observe(document.documentElement, { subtree: true, childList: true, attributes: false });
})();
